// extracted by mini-css-extract-plugin
export default {"textColor":"overview-notifications_textColor__LIrPh","boostLink":"overview-notifications_boostLink__gPzZQ"};